__webpack_require__.p = "/wall-go-wasm/";